import React, {Component} from 'react';
import {ReactPlugin, withAITracking} from '@microsoft/applicationinsights-react-js';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {createBrowserHistory} from "history";
import withRouter from "./withRouter.hook";
import {Props, State} from "./TelemetryService.interfaces";

const browserHistory = createBrowserHistory();

const reactPlugin: any = new ReactPlugin();

class TelemetryService extends Component<Props, State> {

    override componentDidMount() {
        const configurationString = sessionStorage.getItem("app_configuration");
        if (!configurationString) return;
        const configuration = JSON.parse(configurationString);
        const insightKey = configuration?.insightKey;
        if (!insightKey) return;

        const appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: insightKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {
                        history: browserHistory
                    }
                }
            }
        });
        appInsights.loadAppInsights();
    }

    override render() {
        return this.props.children;
    }
}

//@ts-ignore
export default withRouter(withAITracking(reactPlugin, TelemetryService))